module.exports = __webpack_public_path__ + "img/whatnext.34d0e6cf.png";